import React from "react";
import { observer } from "mobx-react-lite";

import "./DownloadProgressSnackbar.scss";
import Button from "../../button/Button";
import { Info } from "../../svg/svgImageList";
import ProgressBarSnackbar from "../../progress-bar-snackbar/ProgressBarSnackbar";
import { translationService } from "../../../services/translation/TranslationService";
import { exportSewerObjectsService } from "../../../services/sewer-object/ExportSewerObjectsService";

export default observer(function DownloadProgressSnackbar() {
  let containerClass = "download-progress";
  if (exportSewerObjectsService.downloadProgressSnackbarIsVisible) {
    containerClass += " show";
  } else {
    containerClass += " hide";
  }

  return (
    <div className={containerClass}>
      <div className="info">
        <Button
          className="svg-info"
          icon={{
            svg: Info,
            width: 30,
            height: 30,
          }}
        />
        <span>
          {translationService.translate("general.download.prepare-sewer-objects", {
            sewerObjectsCount: exportSewerObjectsService.sewerObjectsCount,
          })}
        </span>
      </div>
      <ProgressBarSnackbar percentComplete={exportSewerObjectsService.progress} />
    </div>
  );
});
